import React, { useEffect } from 'react';
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import styles from '../pa_checklist_followup.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { toBrDateWithTime } from '../../../../utils/dateUtils';
import TabInfoComp from './tinyComps/tab_info_tab_comp';
import ImageWithModal from './tinyComps/image_with_modal';

const PAChecklistFollowUpDirTab = () => {
  const { itemSelecionado, infoComp } = usePAChecklistFollowUp();

  const dirColumns = [
    { name: 'Destino', selector: row => row.descricao_destino, width: '30%' },
    { name: 'Grade', selector: row => row.descricao_grade, width: '10%' },
    { name: 'Quantidade', selector: row => row.qtde_pecas, width: '10%' },
    {
      name: 'Defeito - Localização', selector: (row, index) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', margin: '6px 0px' }}>
            {itemSelecionado.analiseDefeitos.map((item, indexDef) => {
              return (item.id_checklist_analise_direcionamento === row.id_checklist_analise_direcionamento ?
                <div key={`defeito_fup_${index}_${indexDef}`} >{item.descricao_defeito} - {item.descricao_localizacao}</div> : null
              )
            })}
            {itemSelecionado.analiseDefeitos.length === 0 && <div>-</div>}
          </div>
        )
      }, width: '50%'
    },
  ];

  return (
    <section className={styles.inner_tab_wrapper}>
      {
        !itemSelecionado.resultadoAnalise &&
        <div className={styles.no_data_message}>Análise checklist ainda não realizada</div>
      }

      {
        itemSelecionado.resultadoAnalise &&
        <>
          <TabInfoComp />

          <div className={styles.separator} />

          {
            itemSelecionado.analiseDirecionamentos.length === 0 &&
            <div className={styles.section_label}>Nenhum direcionamento inserido</div>
          }
          {
            itemSelecionado.analiseDirecionamentos.length > 0 &&
            <div className={styles.inner_tab_wrapper}>
              <div className={styles.section_label}>Direcionamentos</div>
              <Tabela
                columns={dirColumns}
                data={itemSelecionado.analiseDirecionamentos}
                pagination={false}
                highlightOnHover={true}
              />
            </div>
          }

          <div className={styles.separator} />

          {
            itemSelecionado.resChecklistImagens.length === 0 &&
            <div className={styles.section_label}>Nenhuma imagem inserida</div>
          }
          {
            itemSelecionado.resChecklistImagens.length > 0 &&
            <div className={styles.inner_tab_wrapper}>
              <div className={styles.section_label}>Imagens</div>
              <section className={styles.flex_row_wrapper}>
                {itemSelecionado.resChecklistImagens.map((src, i) => {
                  return <ImageWithModal key={i} src={src} i={i} />
                })}
              </section>
            </div>
          }
        </>
      }
    </section>
  );
}

export default PAChecklistFollowUpDirTab;
